import { t } from 'localization'
import { HomepageQA } from 'shared/dataAttributes'
import { mediaQueries } from 'shared/theme'
import { CMSVideoAsset } from 'shared/types/CMSVideoAsset'
import styled from 'styled-components'

type VideoHeroProps = {
  videos: CMSVideoAsset[]
}

const TP = 'homepage.VideoHero'

const VideoHero = ({ videos }: VideoHeroProps) => {
  const [defaultVideo, mobileVideo] = videos
  const { url: urlDefault, poster: posterDefault } = defaultVideo
  const urlMobile = mobileVideo ? mobileVideo.url : urlDefault
  const posterMobile = mobileVideo ? mobileVideo.poster : posterDefault

  return (
    <VideoHeroWrapper>
      <MobileVideo
        autoPlay
        data-qa={HomepageQA.VideoHero}
        disablePictureInPicture
        loop
        muted
        playsInline
        poster={posterMobile?.largeUrl}
        preload="auto"
        src={`${urlMobile}#t=0.5`}
      >
        <source src={urlMobile} type="video/mp4" />
        <source src={urlMobile} type="video/ogg" />
        {t(`${TP}.heroVideoNotSupported`, 'Your browser does not support the video.')}
      </MobileVideo>
      <DesktopVideo
        autoPlay
        data-qa={HomepageQA.VideoHero}
        disablePictureInPicture
        loop
        muted
        playsInline
        poster={posterDefault?.largeUrl}
        preload="auto"
        src={`${urlDefault}#t=0.5`}
      >
        <source src={urlDefault} type="video/mp4" />
        <source src={urlDefault} type="video/ogg" />
        {t(`${TP}.heroVideoNotSupported`, 'Your browser does not support the video.')}
      </DesktopVideo>
    </VideoHeroWrapper>
  )
}

const baseVideoStyles = `
  display: block;
  height: 100vh !important;
  left: 0;
  object-fit: cover !important;
  position: absolute;
  top: 0;
  width: 100vw !important;
`

const MobileVideo = styled.video`
  ${baseVideoStyles}
  display: block;

  ${mediaQueries.desktop} {
    display: none;
  }
`

const DesktopVideo = styled.video`
  ${baseVideoStyles}
  display: none;

  ${mediaQueries.desktop} {
    display: block;
  }
`

const VideoHeroWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
`

export default VideoHero
